// define(["common", "emChart", "template", "suggest"], function (common, emChart, template, suggest2017) {

  var common = require('./common')
  var emChart = require('./emchart')
  var template = require('./template')
  // var suggest = suggest2017

// var renderzx = require('../getzx/renderzx')['default'];//渲染自选股模块



    function baseStock() {
        if (window.stockEnity) {
            this.baseUrl = '//push2.eastmoney.com'
            if(window.server_env == 'test' ){ //|| window.server_env == 'development'
                this.baseUrl = 'http://61.129.249.233:18665'
            }
            //this.baseUrl = 'http://61.152.230.191'
            this.ut = 'bd1d9ddb04089700cf9c27f6f7426281'
            this.code = window.stockEnity.stockCode;
            this.name = window.stockEnity.stockName;
            this.market = window.stockEnity.stockMarket;
            this.newmarket = window.stockEnity.MktNum;
            this.stockId = window.stockEnity.stockId;
            this.gubaCode = window.stockEnity.gubaCode;
            this.debug = window.location.host !== "quote.eastmoney.com" || window.stockEnity.released;
        }
        if (window.location.href.indexOf("eastmoney.com") > 0) {
            document.domain = "eastmoney.com";
        }
        if (typeof baseStock.suggest === "undefined") {
            try {
                var suggest = baseStock.suggest = new suggest2017({
                    inputid: "search_box",
                    offset: { left: -91, top: 5 },
                    shownewtips: true,
                    newtipsoffset: { top: -3, left: 0 }
                });
            } catch (e) {
                console.error(e);
            }
        }
    }

    //新版行情源行情 zxw
    baseStock.prototype.loadnewHqData = function (url, type) {
        var loadData = {
            url: url,
            type: type || '',
            intital: function (fieldList) {
                var self = this;
                self.loadHqData(fieldList);
                setInterval(function () {
                    self.loadHqData(fieldList);
                }, 20000);
            },
            loadHqData: function (fieldList) {
                common.jsonPnew(this.url, function (json) {
                    var data = json.data;
                    var arr = []
                    if (type == 'B') {
                        arr.push(data.f43 == '-' ? '-' : (data.f43 / Math.pow(10, data.f59)).toFixed(data.f59))//0最新价
                        arr.push(data.f44 == '-' ? '-' : (data.f44 / Math.pow(10, data.f59)).toFixed(data.f59))//1最高价
                        arr.push(data.f45 == '-' ? '-' : (data.f45 / Math.pow(10, data.f59)).toFixed(data.f59))//2最低价
                        arr.push(data.f46 == '-' ? '-' : (data.f46 / Math.pow(10, data.f59)).toFixed(data.f59))//3开盘价
                        arr.push(data.f47 == '-' ? '-' : data.f47)//4成交量
                        arr.push(data.f48 == '-' ? '-' : data.f48)//5成交额(f48)
                        arr.push(data.f49 == '-' ? '-' : data.f49)//6外盘
                        arr.push(data.f55.toFixed(2))//7每股收益(f55) 
                        arr.push(data.f59)// 8小数位数(f59)
                        arr.push((data.f60 / Math.pow(10, data.f59)).toFixed(data.f59))//9昨收价(f60)
                        arr.push(data.f84)//10总股本(股)(f84)
                        arr.push(data.f92.toFixed(2))//11每股净资产(f92)
                        arr.push(data.f116)//12总市值(f116)
                        arr.push(data.f126)//13股息率(f126
                        arr.push(data.f152)//14小数位数字段(2)
                        arr.push(data.f161 == '-' ? '-' : data.f161)//15内盘(f161)
                        arr.push(data.f164 / Math.pow(10, data.f152))//16市盈率(TTM)(f164)
                        arr.push(data.f168 == '-' ? '-' : (data.f168 / 100))//17换手率(f168)
                        arr.push(data.f169 == '-' ? '-' : (data.f169 / Math.pow(10, data.f59)).toFixed(data.f59))//18涨跌值(f169) 
                        arr.push(data.f170 == '-' ? '-' : data.f170 / 100)//19涨跌幅(f170) 
                        arr.push(data.f171 == '-' ? '-' : data.f171)//20振幅(f171)
                        arr.push(data.f167 == '-' ? '-' : data.f167 / Math.pow(10, data.f152))//21市净率(f167)
                        arr.push(data.f50 == '-' ? '-' : (data.f50 / Math.pow(10, data.f152)).toFixed(2))//22量比(f50)
                        arr.push(common.formatDate(new Date(data.f86 * 1000), 'yyyy-MM-dd HH:mm:ss'))//23行情时间Unix时间戳，单位秒(f86)
                        arr.push(data.f71 == '-' ? '-' : (data.f71 / Math.pow(10, data.f59)).toFixed(data.f59))//24均价(f71)
                        arr.push(data.f51 == '-' ? '-' : (data.f51 / Math.pow(10, data.f59)).toFixed(data.f59))//25涨停价
                        arr.push(data.f52 == '-' ? '-' : (data.f52 / Math.pow(10, data.f59)).toFixed(data.f59))//26跌停价
                        arr.push(data.f117)//27流通市值(f117)
                        arr.push(data.f191 == '-' ? '-' : (data.f191 / 100))//28委比
                        arr.push(data.f192)//29委差
                        arr.push(data.f162)//30市盈率(动态)
                        arr.push(data.f167)//31市净率

                        //行情时间
                        $("#stock_time").html("(" + common.formatDate(new Date(data.f86 * 1000), 'yyyy-MM-dd HH:mm:ss') + ")");
                    } else if (type == 'qq') {
                        arr.push(data.f43 == '-' ? '-' : (data.f43 / Math.pow(10, data.f59)).toFixed(1))//0最新价
                        arr.push(data.f44 == '-' ? '-' : (data.f44 / Math.pow(10, data.f59)).toFixed(1))//1最高价
                        arr.push(data.f45 == '-' ? '-' : (data.f45 / Math.pow(10, data.f59)).toFixed(1))//2最低价
                        arr.push(data.f46 == '-' ? '-' : (data.f46 / Math.pow(10, data.f59)).toFixed(1))//3开盘价
                        arr.push(data.f47 == '-' ? '-' : data.f47)//4成交量
                        arr.push(data.f48 == '-' ? '-' : data.f48)//5成交额(f48)
                        arr.push(data.f49 == '-' ? '-' : data.f49)//6外盘
                        arr.push(data.f59)// 7小数位数(f59)
                        arr.push((data.f60 / Math.pow(10, data.f59)).toFixed(1))//8昨收价(f60)
                        arr.push(data.f152)//9小数位数字段(2)
                        arr.push(data.f161 == '-' ? '-' : data.f161)//10内盘(f161)
                        arr.push(data.f169 == '-' ? '-' : (data.f169 / Math.pow(10, data.f59)).toFixed(1))//11涨跌值(f169) 
                        arr.push(data.f170 == '-' ? '-' : (data.f170 / 100).toFixed(2))//12涨跌幅(f170) 
                        arr.push(data.f171 == '-' ? '-' : (data.f171 / 100).toFixed(2))//13振幅(f171)
                        arr.push(data.f50 == '-' ? '-' : data.f50 / Math.pow(10, data.f152))//14量比(f50)
                        arr.push(common.formatDate(new Date(data.f86 * 1000), 'yyyy-MM-dd HH:mm:ss'))//15行情时间Unix时间戳，单位秒(f86)
                        arr.push(data.f19 == 0 ? '-' : (data.f19 / Math.pow(10, data.f59)).toFixed(1))//16买入价
                        arr.push(data.f39 == 0 ? '-' : (data.f39 / Math.pow(10, data.f59)).toFixed(1))//17卖出价
                        $("#stock_time").html("(" + common.formatDate(new Date(data.f86 * 1000), 'yyyy-MM-dd HH:mm:ss') + ")");
                    }
                    var stockData = []
                    for (var i = 0; i < arr.length; i++) {
                        stockData.push(arr[i] + '')
                    }
                    var zsjIndex, zdeIndex = 0;
                    //获取最新价和涨跌额的index
                    for (var i = 0; i < fieldList.length; i++) {
                        var item = fieldList[i];
                        if (item.name == "zsj") {
                            zsjIndex = item.num;
                        }
                        if (item.name == "zde") {
                            zdeIndex = item.num;
                        }
                    }
                    for (var i = 0; i < fieldList.length; i++) {
                        var field = fieldList[i];
                        var data = stockData[field.num];
                        //振幅和涨跌幅加百分比
                        if (field.name == "zf" || field.name == "zdf" || field.name == "hsl" || field.name == "wb" || field.name == "roe") {
                            //if (data > 10000) data = data.split('.')[0];
                            data = data === "-" ? "-" : data + "%";
                        } else if (field.name == "syl" || field.name == "sjl") {
                            data = data === "-" ? "-" : data / 100;
                        } else {
                            data = data === "-" ? "-" : data;
                        }
                        //开平
                        if (field.name == "kp") {
                            if (data == -1) {
                                data = "-";
                            } else if (data == 0) {
                                data = "双开";
                            } else if (data == 1) {
                                data = "双平";
                            } else if (data == 2) {
                                data = "多换";
                            } else if (data == 3) {
                                data = "多开";
                            } else if (data == 4) {
                                data = "多平";
                            } else if (data == 5) {
                                data = "空换";
                            } else if (data == 6) {
                                data = "空开";
                            } else if (data == 7) {
                                data = "空平";
                            }
                        }
                        //万百万缩写
                        if (field.NumbericFormat && data) {
                            data = data.NumbericFormat();
                        }
                        $("." + field.name).html(data);

                        if (field.hasColor) {
                            var zsj = stockData[zsjIndex];
                            $("." + field.name).removeClass("red").removeClass("green");
                            if (field.name == "wb" || field.name == "wc" || field.name == "rz" || field.name == "cc") {
                                $("." + field.name).addClass(common.getColor(data));
                            } else if (field.name != "zxj" && field.name != "zdf" && field.name != "zde") {
                                if (data > zsj) {
                                    $("." + field.name).addClass("red");
                                } else if (data < zsj) {
                                    $("." + field.name).addClass("green");
                                }
                            } else {
                                var zde = stockData[zdeIndex];
                                if (zde != 0 && zde != "-") {
                                    if (zde.isPositive()) {
                                        $("." + field.name).addClass("red");
                                        $("#arrow-find").removeClass("down-arrow").addClass("up-arrow");
                                    } else {
                                        $("." + field.name).addClass("green");
                                        $("#arrow-find").removeClass("up-arrow").addClass("down-arrow");
                                    }
                                } else {
                                    $("#arrow-find").removeClass("up-arrow").removeClass("down-arrow");
                                }
                            }
                        }
                    }

 
                    //涨跌平
                    var zdpList = stockData[25].split("|");
                    if ($(".pjs").length > 0) {
                        $(".zjs").html(zdpList[0]);
                        $(".pjs").html(zdpList[1]);
                        $(".djs").html(zdpList[2]);
                    }
                    //阶段涨跌幅
                    var jdzdfList = stockData[26].split("|");
                    if ($(".5day").length > 0) {
                        $(".5day").html(jdzdfList[0]);
                        jdzdfList[0].isPositive() ? $(".5day").addClass("red") : $(".5day").addClass("green");
                        $(".20day").html(jdzdfList[2]);
                        jdzdfList[2].isPositive() ? $(".20day").addClass("red") : $(".20day").addClass("green");
                        $(".60day").html(jdzdfList[3]);
                        jdzdfList[3].isPositive() ? $(".60day").addClass("red") : $(".60day").addClass("green");
                        $(".tillNow").html(jdzdfList[4]);
                        jdzdfList[4].isPositive() ? $(".tillNow").addClass("red") : $(".tillNow").addClass("green");
                    }
                });
            }
        }
        return loadData;
    }

    // 快速行情
    baseStock.prototype.loadHqData = function () {
        var loadData = {
            url: "http://nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx?type=CT&cmd=" + this.stockId + "&sty=FDPBPFB&st=z&sr=&p=&ps=&cb=?&js=([[(x)]])&token=7bc05d0d4c3c22ef9fca8c2a912d779c",
            intital: function (fieldList) {
                var self = this;
                self.loadHqData(fieldList);
                setInterval(function () {
                    self.loadHqData(fieldList);
                }, 20000);
            },
            loadHqData: function (fieldList) {
                common.jsonP(this.url, function (json) {
                    if (json && json[0] && json[0][0].stats != false) {
                        var stockData = json[0][0].split(',');
                        var zsjIndex, zdeIndex = 0;
                        //获取最新价和涨跌额的index
                        for (var i = 0; i < fieldList.length; i++) {
                            var item = fieldList[i];
                            if (item.name == "zsj") {
                                zsjIndex = item.num;
                            }
                            if (item.name == "zde") {
                                zdeIndex = item.num;
                            }
                        }

                        for (var i = 0; i < fieldList.length; i++) {
                            var field = fieldList[i];

                            var data = stockData[field.num];
                            //振幅和涨跌幅加百分比
                            if (field.name == "zf" || field.name == "zdf" || field.name == "hsl" || field.name == "wb" || field.name == "roe") {
                                if (data > 10000) data = data.split('.')[0];
                                data = data === "-" ? "-" : data + "%";
                            } else {
                                data = data === "-" ? "-" : data;
                            }

                            //开平
                            if (field.name == "kp") {
                                if (data == -1) {
                                    data = "-";
                                } else if (data == 0) {
                                    data = "双开";
                                } else if (data == 1) {
                                    data = "双平";
                                } else if (data == 2) {
                                    data = "多换";
                                } else if (data == 3) {
                                    data = "多开";
                                } else if (data == 4) {
                                    data = "多平";
                                } else if (data == 5) {
                                    data = "空换";
                                } else if (data == 6) {
                                    data = "空开";
                                } else if (data == 7) {
                                    data = "空平";
                                }
                            }
                            //万百万缩写
                            if (field.NumbericFormat && data) {
                                data = data.NumbericFormat();
                            }
                            $("." + field.name).html(data);

                            if (field.hasColor) {
                                var zsj = stockData[zsjIndex];
                                $("." + field.name).removeClass("red").removeClass("green");
                                if (field.name == "wb" || field.name == "wc" || field.name == "rz" || field.name == "cc") {
                                    $("." + field.name).addClass(common.getColor(data));
                                } else if (field.name != "zxj" && field.name != "zdf" && field.name != "zde") {
                                    if (data > zsj) {
                                        $("." + field.name).addClass("red");
                                    } else if (data < zsj) {
                                        $("." + field.name).addClass("green");
                                    }
                                } else {
                                    var zde = stockData[zdeIndex];
                                    if (zde != 0 && zde != "-") {
                                        if (zde.isPositive()) {
                                            $("." + field.name).addClass("red");
                                            $("#arrow-find").removeClass("down-arrow").addClass("up-arrow");
                                        } else {
                                            $("." + field.name).addClass("green");
                                            $("#arrow-find").removeClass("up-arrow").addClass("down-arrow");
                                        }
                                    } else {
                                        $("#arrow-find").removeClass("up-arrow").removeClass("down-arrow");
                                    }
                                }
                            }
                        }

                        //行情时间
                        $("#stock_time").html("(" + stockData[3] + ")");

                        //涨跌平
                        var zdpList = stockData[25].split("|");

                        if ($(".pjs").length > 0) {
                            $(".zjs").html(zdpList[0]);
                            $(".pjs").html(zdpList[1]);
                            $(".djs").html(zdpList[2]);
                        }

                        //阶段涨跌幅
                        var jdzdfList = stockData[26].split("|");

                        if ($(".5day").length > 0) {
                            $(".5day").html(jdzdfList[0]);
                            jdzdfList[0].isPositive() ? $(".5day").addClass("red") : $(".5day").addClass("green");
                            $(".20day").html(jdzdfList[2]);
                            jdzdfList[2].isPositive() ? $(".20day").addClass("red") : $(".20day").addClass("green");
                            $(".60day").html(jdzdfList[3]);
                            jdzdfList[3].isPositive() ? $(".60day").addClass("red") : $(".60day").addClass("green");
                            $(".tillNow").html(jdzdfList[4]);
                            jdzdfList[4].isPositive() ? $(".tillNow").addClass("red") : $(".tillNow").addClass("green");

                        }
                    }
                });
            }
        }
        return loadData;
    }


    //加载排行模板新 zxw
    baseStock.prototype.loadRankTemplatenew = function (setting) {
        var url = setting.url
        var dom = setting.dom
        var link = setting.link
        common.jsonPnew(url, function (json) {
            var htm = "";
            var list = json.data.diff
            if (list instanceof Array) {
                for (var i = 0; i < list.length; i++) {
                    var price = list[i].f2 == '-' ? '-' : (list[i].f2).toFixed(list[i].f1)
                    var percent = list[i].f3 == '-' ? '-' : (list[i].f3.toFixed(2) + '%')
                    var color = list[i].f3 > 0 ? 'red' : list[i].f3 < 0 ? 'green' : ''
                    var link = setting.link.replace("{{code}}", list[i].f12)
                    if (link.indexOf('forex') > -1) {
                        link = link.replace("forex", list[i].f13 == 120 ? 'cnyrate' : 'forex')
                    }

                    var stockCode = list[i].f12;
                    if (stockCode == "399001" || stockCode == "000001" || stockCode == "000300" || stockCode == "399006" || stockCode == "399005") {
                        link = "//quote.eastmoney.com/zs" + stockCode + ".html";
                    }

                    htm += '<tr>'
                        + '<td><a href="' + link + '" title="' + list[i].f14 + '" target="_blank">' + list[i].f14.cutstr(10, "...") + '</a></td>'
                        + '<td class="' + color + '">' + price + '</td><td class="' + color + '">' + percent + '</td>'
                        + '</tr>'
                }
            } else {
                for (var i in list) {
                    var price = (list[i].f2 / Math.pow(10, list[i].f1)).toFixed(list[i].f1)
                    var percent = (list[i].f3 / Math.pow(10, list[i].f152)).toFixed(2) + '%'
                    var color = list[i].f3 > 0 ? "red" : list[i].f3 < 0 ? "green" : ""
                    var link = setting.link.replace("{{code}}", list[i].f12)
                    if (link.indexOf('forex') > -1) {
                        link = link.replace("forex", list[i].f13 == 120 ? 'cnyrate' : 'forex')
                    }

                    var stockCode = list[i].f12;
                    if (stockCode == "399001" || stockCode == "000001" || stockCode == "000300" || stockCode == "399006" || stockCode == "399005") {
                        link = "//quote.eastmoney.com/zs" + stockCode + ".html";
                    }

                    htm += '<tr>'
                        + '<td><a href="' + link + '" title="' + list[i].f14 + '" target="_blank">' + list[i].f14.cutstr(10, "...") + '</a></td>'
                        + '<td class="' + color + '">' + price + '</td><td class="' + color + '">' + percent + '</td>'
                        + '</tr>'
                }
            }
            $(dom).html(htm)

        })
    }

    /**
    * 加载排行模板
    * @param  {object} settings
    * 
    * 已不用
    */
    baseStock.prototype.loadRankTemplate = function (settings) {
        var tpl = '{{each list as val idx}}<tr>'
            + '<td><a href="{{val.link}}" title="{{val.title || val.name}}" target="_blank">{{val.name}}</a></td>'
            + '<td class="{{val.color}}">{{val.close}}</td><td class="{{val.color}}">{{val.changePercent}}</td>'
            + '</tr>{{/each}}';
        var _this = this;
        var _default = {
            interval: 0,
            template: tpl,
            link: "//quote.eastmoney.com/web/r/{{code}}{{market}}",
            ajax: {
                url: "//nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx",
                type: "GET",
                data: {
                    type: "CT",
                    cmd: "",
                    sty: "E1II",
                    st: "(ChangePercent)",
                    sr: -1,
                    js: "([(x)])",
                    ps: 5,
                    token: "4f1862fc3b5e77c150a2b985b12db0fd"
                },
                dataType: "jsonp",
                jsonp: "cb"
            },
            dataResolver: function (json) {
                var context = new Object(),
                    models = [];
                if (json instanceof Array) {
                    for (var i = 0; i < json.length; i++) {
                        if (!isNaN(settings.count) && i >= settings.count) break;
                        var data = json[i];
                        if (typeof data !== "string") continue;
                        var items = data.split(',');
                        var _model = {
                            code: items[0],
                            market: items[1],
                            title: items[2],
                            name: common.cutstr(items[2], 10, "..."),
                            close: items[3],
                            changePercent: items[4],
                            color: items[4] === "0" || items[4] === "-" ? "" : items[4].isPositive() ? "red" : "green"
                        };
                        _model.link = template.render(_settings.link, _model);
                        models.push(_model);
                    }
                    context["list"] = models;
                }
                return context;
            }
        };
        if (settings.ajax) {
            settings.ajax.data = $.extend(_default.ajax.data, settings.ajax.data);
        }
        settings.ajax = $.extend(_default.ajax, settings.ajax);
        if (typeof settings.cmd === "string" && !settings.ajax.data.cmd)
            settings.ajax.data["cmd"] = settings.cmd;
        if (typeof settings.count === "number" && settings.count > 0)
            settings.ajax.data["ps"] = settings.count;
        if (typeof settings.callback === "string")
            settings.ajax["jsonpCallback"] = settings.callback;
        var _settings = $.extend(_default, settings);
        var $dom = $(_settings.dom);
        if ($dom.length === 0 && typeof _settings.dom === "string") {
            var _dom = document.getElementById(_settings.dom);
            if (_dom) $dom = $(_dom);
            else throw "dom not found";
        }
        _settings.ajax.success = function (json) {
            if (typeof settings.callback === "function") { settings.callback(json); }
            if (!json) return;
            var model, html;
            if (typeof _settings.dataResolver === "function") {
                model = _settings.dataResolver(json);
            }
            if (typeof _settings.callback === "function")
                _settings.callback($dom, model, _settings);
            if (typeof _settings.template === "string") {
                html = render(_settings.template, model);
            }
            else if (typeof _settings.template === "function") {
                var temp = _settings.template(context, _settings);
                html = render(temp, model);
            }
            if (html) $dom.html(html);
        };
        var render = function (tpl, model) {
            var _model = model || {};
            if (document.getElementById(tpl))
                return template(tpl, _model);
            else
                return template.render(tpl, _model);
        };
        var auto = $.dataAutoRefresh(_settings.ajax);
        if (_settings.interval > 0) {
            auto.intInterval = _settings.interval;
            auto.start();
        }
        else { auto.load(); }
        return auto;
    }

    /** 
    * 新版快速行情
    * @param {object} settings: 配置
    */
    baseStock.prototype.loadQuoteData = function (settings) {
        var _this = this;
        var _defualt = {
            ajax: {
                url: "//nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx",
                data: {
                    type: "CT",
                    cmd: _this.stockId,
                    sty: "FDPBPFB",
                    st: "z",
                    js: "((x))",
                    token: "4f1862fc3b5e77c150a2b985b12db0fd"
                },
                dataType: "jsonp"
            },
            interval: window.defaultInterval || 20 * 1000,
            fields: []
        };
        if (settings.ajax) {
            if (settings.ajax.data) {
                settings.ajax.data = $.extend(_defualt.ajax.data, settings.ajax.data);
            }
            settings.ajax = $.extend(_defualt.ajax, settings.ajax);
        }
        var _settings = $.extend(_defualt, settings);
        _settings.ajax.success = function (json) {
            if (!json) return;
            var data;
            if (typeof _settings.dataResolver === "function") {
                data = _settings.dataResolver(json);
            }
            else if (typeof (json) === "string") {
                data = json.split(',');
            }
            for (var i = 0; i < _settings.fields.length; i++) {
                var field = _settings.fields[i] ? _settings.fields[i] : {};
                var item = data[field.num || 0] + '',
                    //item = field.fixed?data[field.num || 0].toFixed(data[field.fixed]):item
                    $dom = $("." + field.name),
                    changed = false;
                if (typeof field.handler === 'function') {
                    item = field.handler.apply(_this, [item, field, _settings]);
                }
                if (!item || $dom.length == 0) continue;
                // 是否科学计数
                if (field.NumbericFormat) {
                    item = item.NumbericFormat();
                }
                // 枚举映射
                if (typeof (field.map) === "object" && field.map[item]) {
                    item = field.map[item];
                }
                // 呈现模板
                if (typeof field.template === "string") {
                    var model = new Object();
                    model[field.paramName || "data"] = item;
                    item = template.render(field.template, model);
                }
                changed = $dom.html() != item;
                //if (!changed) continue;
                $dom.html(item);
                // 颜色处理
                if (field.hasColor) {
                    var css = "", blink_model = 0;
                    $dom.removeClass("red").removeClass("green");
                    if (!isNaN(field.comparer)) {
                        css = field.comparer < 0 ? "green" : field.comparer > 0 ? "red" : "";
                        blink_model = field.comparer > 0 ? 1 : field.comparer < 0 ? -1 : 0;
                    }
                    else if (typeof field.comparer === "function") {
                        var c = field.comparer(data);
                        css = c < 0 ? "green" : c > 0 ? "red" : "";
                        blink_model = c > 0 ? 1 : c < 0 ? -1 : 0;
                    }
                    else {
                        css = common.getColor(item);
                        item = typeof item === "string" ? item : item.toString();
                        blink_model = item == "0" || item == "-" ? 0 : item.isPositive() ? 1 : -1;
                    }
                    $dom.addClass(css);
                    // 闪烁效果
                    if (field.blink && changed) {
                        if (blink_model === 1) {
                            $dom.textBlink({ color: ["#FFDDDD", "#FFEEEE", ""], blinktime: 150 });
                        }
                        else if (blink_model === -1) {
                            $dom.textBlink({ color: ["#b4f7af", "#ccffcc", ""], blinktime: 150 });
                        }
                    }
                }
                // 字段呈现回调
                if (typeof (field.render) === "function") {
                    field.render($dom, data[field.num || 0] + '', data, _settings);
                }
            }
        };
        var auto = $.dataAutoRefresh(_settings.ajax);
        auto.intInterval = _settings.interval;
        auto.start();
        return auto;
    }

    /** 
    * 新版个股新闻行情
    * @param {object} settings: 配置
    */
    baseStock.prototype.bindStockNews = function (settings) {
        var tpl = $("#tmp_news").html() || "{{if Status === 0 && Data.length>0}}"
            + "<ul class=\"article_list nlist\">"
            + "{{each Data as val idx}}<li>"
            + "<a href=\"{{val.Art_Url}}\" title=\"{{val.Art_Title}}\" target=\"_blank\" class=\"fl\">{{val.Art_Title | cutstr:42,'...'}}</a>"
            + "<i class=\"fr\">{{val.Art_ShowTime | formatDate:'MM-dd'}}</i>"
            + "</li>{{/each}}"
            + "</ul>{{else}}"
            + "<div class=\"nonslist\">暂无该股新闻</div>"
            + "{{/if}}";
        var _settings;
        var _default = {
            tpl: tpl,
            dom: $("#stocknews"),
            api: {
                url: "//searchapi.eastmoney.com/api/Info/Search?isAssociation20=True&highlights20=null&pageIndex20=1&pageSize20=5&returnFields20=Art_Title|0,Art_Url|0,Art_ShowTime&type=20&token=E5303D4106DC91E17D35009B8830D33D&sort20=Art_ShowTime|0",
                data: { and20: "multimatch/Art_Title,Art_Content/" + encodeURIComponent(stockEnity.stockName) + "/True" },
                dataType: "jsonp",
                jsonp: "cb",
                success: function (json) {
                    if (!json) json = { Status: -1 };
                    $(_settings.dom).html(template.render(_settings.tpl, json));
                }
            }
        };
        if (settings && settings.api) {
            settings.api = $.extend(_default.api, settings.api);
        }
        _settings = $.extend(_default, settings);
        if (settings) {
            if (typeof _settings.dom === "string") {
                var query = _settings.dom;
                _settings.dom = document.getElementById(query);
                if (!ele) _settings.dom = $(query);
            }
            if (typeof settings.callback === "function") {
                _default.api.success = settings.callback;
            }
            if (typeof settings.api.data !== "undefined") {
                $.extend(_default.api.data, settings.api.data);
            }
        }
        return $.ajax(_settings.api);
    }


    // 新行情五档，分时  zxw
    baseStock.prototype.loadDetailDatanew = function () {
        var base = this
        var url = base.baseUrl + "/api/qt/stock/get?secid=" + window.stockEnity.fullcode + "&ut=" + base.ut + "&fields=f531,f59,f60&invt=2"
        common.jsonPnew(url, function (json) {
            if (!json.data) return
            var data = json.data
            var zs = data.f60
            //$(".wb").text(data.f191 == '-' ? '-' : ((data.f191 / 100).toFixed(2) + '%')).addClass(data.f191 > 0 ? 'red' : data.f191 < 0 ? 'green' : '')
            //$(".wc").text(data.f192).addClass(data.f192 > 0 ? 'red' : data.f192 < 0 ? 'green' : '')
            var sellList = [
                {
                    label: '卖五',
                    price: data.f31,
                    volume: data.f32
                }, {
                    label: '卖四',
                    price: data.f33,
                    volume: data.f34
                }, {
                    label: '卖三',
                    price: data.f35,
                    volume: data.f36
                }, {
                    label: '卖二',
                    price: data.f37,
                    volume: data.f38
                }, {
                    label: '卖一',
                    price: data.f39,
                    volume: data.f40
                }
            ]
            var buyList = [
                {
                    label: '买一',
                    price: data.f19,
                    volume: data.f20
                }, {
                    label: '买二',
                    price: data.f17,
                    volume: data.f18
                }, {
                    label: '买三',
                    price: data.f15,
                    volume: data.f16
                }, {
                    label: '买四',
                    price: data.f13,
                    volume: data.f14
                }, {
                    label: '买五',
                    price: data.f11,
                    volume: data.f12
                }
            ]
            var html_sell = ''
            var html_buy = ''
            for (var i = 0; i < buyList.length; i++) {
                var color = buyList[i].price > zs ? 'red' : buyList[i].price < zs ? 'green' : ''
                var price = buyList[i].price == '-' ? '-' : ((buyList[i].price / Math.pow(10, data.f59)).toFixed(data.f59))
                html_buy += '<tr><td class="tac">' + buyList[i].label + '</td><td class="' + color + '">' + price + '</td><td class="td3">' + buyList[i].volume + '</td></tr>'
            }
            for (var i = 0; i < sellList.length; i++) {
                var color = sellList[i].price > zs ? 'red' : sellList[i].price < zs ? 'green' : ''
                var price = sellList[i].price == '-' ? '-' : ((sellList[i].price / Math.pow(10, data.f59)).toFixed(data.f59))
                html_sell += '<tr><td class="tac">' + sellList[i].label + '</td><td class="' + color + '">' + price + '</td><td class="td3">' + sellList[i].volume + '</td></tr>'
            }
            $("#sell_table tbody").html(html_sell);
            $("#buy_table tbody").html(html_buy);

        });
    }

    // 五档，分时
    baseStock.prototype.loadDetailData = function () {
        common.jsonP("http://nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx?type=CT&cmd=" + this.stockId + "&sty=FDTHTB&st=z&sr=&p=&ps=&cb=?&js=([(x)])&token=7bc05d0d4c3c22ef9fca8c2a912d779c", function (json) {
            if (json && json[0]) {
                var stockData = json[0].split(',');
                var html_sell = "<tbody>";
                var html_buy = "<tbody>";
                var html_deal = "<tbody>";
                var numList = ["一", "二", "三", "四", "五"];

                var zs = stockData[3];
                var color = "";
                for (var i = 10; i < 15; i++) {
                    if (stockData[24 - i] > zs) {
                        color = "red";
                    } else if (stockData[24 - i] < zs) {
                        color = "green";
                    }
                    html_sell += '<tr><td class="tac">卖' + numList[14 - i] + '</td><td class="' + color + '">' + stockData[24 - i] + '</td><td class="td3">' + stockData[34 - i] + '</td></tr>';
                }

                color = "";
                for (var j = 5; j < 10; j++) {
                    if (stockData[j] > zs) {
                        color = "red";
                    } else if (stockData[j] < zs) {
                        color = "green";
                    }
                    html_buy += '<tr><td class="tac">买' + numList[j - 5] + '</td><td class="' + color + '">' + stockData[j] + '</td><td class="td3">' + stockData[j + 10] + '</td></tr>';
                }

                var dealEntity = stockData[25];
                if (dealEntity && dealEntity != "-") {
                    var dealList = dealEntity.split("|");

                    var count = dealList.length >= 9 ? dealList.length - 9 : 0;

                    for (var k = dealList.length - 1; k >= count; k--) {
                        var itemList = dealList[k].split("~");
                        var arrow = itemList[3] == "-1" ? "↓" : itemList[3] == "1" ? "↑" : "";
                        var arrowColor = itemList[3] == "-1" ? "green" : itemList[3] == "1" ? "red" : "";
                        var dataColor = "";
                        if (stockData[3] < itemList[1]) {
                            dataColor = "red";
                        } else if (stockData[3] > itemList[1]) {
                            dataColor = "green";
                        }
                        html_deal += '<tr><td>' + itemList[0] + '</td><td class="' + dataColor + '">' + (itemList[1] || "-") + '</td>'
                            + '<td class="chjl ' + arrowColor + '">' + (itemList[2] || "-") + arrow + '</td></tr>';
                    }
                }
                else {
                    html_deal += "<tr><td>暂无数据</td></tr>";
                }

                html_sell += "</tbody>";
                html_buy += "</tbody>";
                html_deal += "</tbody>";

                $("#sell_table").html(html_sell);
                $("#buy_table").html(html_buy);
                $("#deal_table").html(html_deal);
            }
        });
    }

    // 行情图片事件绑定
    baseStock.prototype.bindChartImgEvent = function (options) {
        var self;
        var defualtUrls = {
            "url_r": "//webquotepic.eastmoney.com/GetPic.aspx?token=44c9d251add88e27b65ed86506f6e5da",
            "url_k": "//webquoteklinepic.eastmoney.com/GetPic.aspx?token=44c9d251add88e27b65ed86506f6e5da"



            //"url_k": (window.stockEnity.MktNum == '90' || window.stockEnity.MktNum == '105'|| window.stockEnity.MktNum == '106' || window.stockEnity.MktNum == '107') ? "//webquoteklinepic.eastmoney.com/GetPic.aspx?token=44c9d251add88e27b65ed86506f6e5da" : "//pifm.eastmoney.com/EM_Finance2014PictureInterface/Index.aspx?token=44c9d251add88e27b65ed86506f6e5da"
        };
        if(window.server_env == 'test'){ //window.server_env == 'development' || 
            defualtUrls.url_r = 'http://61.129.249.32:8870/GetPic.aspx?token=44c9d251add88e27b65ed86506f6e5da'
            defualtUrls.url_k = 'http://61.129.249.32:8871/GetPic.aspx?token=44c9d251add88e27b65ed86506f6e5da'
        }


        var _options = $.extend(defualtUrls, options);
        return {
            unitWidth: -6,
            stockId: this.stockId,
            bindEvent: function () {
                if (!self) self = this;
                $("#pictit span").click(function () {
                    $("#pictit span").removeClass("cur");
                    $(this).addClass("cur");
                    self.changeImg("k");
                });

                $("#zkeya li").click(function () {
                    $("#zkeya li").removeClass("at");
                    $(this).addClass("at");
                    self.changeImg("k");
                });

                $("#zkeyb li").click(function () {
                    $("#zkeyb li").removeClass("at");
                    $("#zkeyc li").removeClass("at");
                    $(this).addClass("at");
                    $("#zkeyc li[type=" + $(this).attr("type") + "]").addClass("at");
                    self.changeImg("k");
                });

                $("#zkeyc li").click(function () { 
                    $("#zkeyb li").removeClass("at");
                    $("#zkeyc li").removeClass("at");
                    $(this).addClass("at");
                    $("#zkeyb li[type=\"" + $(this).attr("type") + "\"]").addClass("at");
                    self.changeImg("k");
                });

                $("#picklc").click(function () {
                    if (self.unitWidth <= -8) {
                        return;
                    }
                    self.unitWidth = self.unitWidth - 1;
                    self.changeImg("k");
                });

                $("#picksd").click(function () {
                    if (self.unitWidth >= 0) {
                        return;
                    }
                    self.unitWidth = self.unitWidth + 1;
                    self.changeImg("k");
                });

                
                $("#actTabImg span").click(function () {
                    $("#actTabImg span").removeClass("cur");
                    $(this).addClass("cur");
                    self.changeImg("r");

                });
                
                //分时
                // $("#actTabFs span").click(function () {
                //     $("#actTabFs span").removeClass("cur");
                //     $(this).addClass("cur");
                // });
                //分时切换绑定事件

                var that = this;
                var  timer = null;
                timer = setInterval(function () {
                    emChart.bindJs({})
                }, 20 * 1000);
                $("#actTabFs span").click(function () {
                    clearInterval(timer)
                    $("#actTabFs span").removeClass("cur");
                    $(this).addClass("cur");
                    var fstype = "", ndays = "1", iscr = "0", iscca="0";
                    var val = $(this).attr("type")
                    switch (val) {
                        case "PQ":
                            ndays = "1";
                            fstype = "r";
                            iscr = "1"
                            break;
                        case "M0":
                            ndays = "1";
                            fstype = "r"
                            break;
                        case "M1":
                            ndays = "2";
                            fstype = "t2"
                            break;
                        case "M2":
                            ndays = "3";
                            fstype = "t3"
                            break;
                        case "M3":
                            ndays = "4";
                            fstype = "t4"
                            break;
                        case "M4":
                            ndays = "5";
                            fstype = "t5"
                            break;
                    }

                    var opt = {
                        iscr: iscr,
                        ndays: ndays,
                        type: fstype,
                        iscca: iscca
                    };

                    emChart.bindJs(opt)

                    timer = setInterval(function () {
                        emChart.bindJs(opt)
                    }, 20 * 1000);
                });
            },
            changeImg: function (type) {
                if (!self) self = this;
                if (typeof type === "string") {
                    switch (type) {
                        case "r":
                            var rtype = $("#actTabImg .cur").attr("type");
                            params = {
                                nid: stockEnity.UnifiedID ? stockEnity.UnifiedID : (stockEnity.MktNum + '.' + stockEnity.stockCode),
                                type: rtype === "M0" ? "" : rtype === "PQ" ? "" : rtype || "r",
                                imageType: rtype === "PQ" ? "rc" : (rtype === "M0" || !rtype) ? "rf" : "t"
                            }
                            //var params = {}
                            //if (window.stockEnity.MktNum == '90' || window.stockEnity.MktNum == '105' || window.stockEnity.MktNum == '106' || window.stockEnity.MktNum == '107') {
                            //    params = {
                            //        nid: stockEnity.UnifiedID ? stockEnity.UnifiedID : (stockEnity.MktNum + '.' + stockEnity.stockCode),
                            //        type: rtype === "M0" ? "" : rtype === "PQ" ? "" : rtype || "r",
                            //        imageType: rtype === "PQ" ? "rc" : (rtype === "M0" || !rtype) ? "rf" : "t"
                            //    }
                            //} else {
                            //    params = {
                            //        id: self.stockId,
                            //        type: rtype === "M0" ? "" : rtype === "PQ" ? "" : rtype || "r",
                            //        imageType: rtype === "PQ" ? "rc" : (rtype === "M0" || !rtype) ? "rf" : "t"
                            //    }

                            //}
                            loadimg("picr", 276, 578, _options.url_r, params, "//hqres.eastmoney.com/EMQuote_Lib/img/picrnotfund.gif");
                            break;
                        case "k":
                            // K图
                            params2 = {
                                nid: stockEnity.UnifiedID ? stockEnity.UnifiedID : (stockEnity.MktNum + '.' + stockEnity.stockCode),
                                type: $("#pictit .cur").attr("type"),
                                unitWidth: self.unitWidth,
                                ef: $("#zkeya .at").attr("type") ? $("#zkeya .at").attr("type") : "",
                                formula: $("#zkeyb .at").attr("type"),
                                imageType: "KXL"
                            }
                            //var params2 = {}
                            //if (window.stockEnity.MktNum == '90' || window.stockEnity.MktNum == '105' || window.stockEnity.MktNum == '106' || window.stockEnity.MktNum == '107') {
                            //    params2 = {
                            //        nid: stockEnity.UnifiedID ? stockEnity.UnifiedID : (stockEnity.MktNum + '.' + stockEnity.stockCode),
                            //        type: $("#pictit .cur").attr("type"),
                            //        unitWidth: self.unitWidth,
                            //        ef: $("#zkeya .at").attr("type") ? $("#zkeya .at").attr("type") : "",
                            //        formula: $("#zkeyb .at").attr("type"),
                            //        imageType: "KXL"
                            //    }
                            //} else {
                            //    params2 = {
                            //        id: self.stockId,
                            //        type: $("#pictit .cur").attr("type"),
                            //        unitWidth: self.unitWidth,
                            //        ef: $("#zkeya .at").attr("type") ? $("#zkeya .at").attr("type") : "",
                            //        formula: $("#zkeyb .at").attr("type"),
                            //        imageType: "KXL"
                            //    }

                            //}
                            loadimg("pick", 365, 520, _options.url_k, params2, "//emcharts.eastmoney.com/images/picknotfund.gif");
                            break;
                        default: break;
                    }
                }
                else {
                    self.changeImg("r");
                    self.changeImg("k");
                }

                function loadimg(container, height, width, url, data, errurl) {
                    var $container = $("#" + container);
                    if ($container.length === 0) return false;
                    $.imgLoader({
                        url: url,
                        data: data,
                        height: height,
                        width: width,
                        success: function (image) {
                            $container.html(image);
                        },
                        error: function (image) {
                            $container.html($(image).attr("src", errurl || "//emcharts.eastmoney.com/images/picknotfund.gif"));
                        }
                    });
                }
            }
        };
    }

    // 股市直播
    baseStock.prototype.stockBroadcast = function () {

        var stockBroadcast = {

            init: function () {
                var self = this;
                self.setNews();
                $("#kx_fontsize").click(function () {
                    if ($(".kx_list").hasClass("kx_fz14")) {
                        $(".kx_list").removeClass("kx_fz14");
                        $(this).html("大字+");
                    } else {
                        $(".kx_list").addClass("kx_fz14");
                        $(this).html("小字-");
                    }
                });
                $("#kx_refresh").off()
                $("#kx_refresh").click(function () {
                    self.setNews();
                });
            },
            setNews: function () {
                var url = "//newsinfo.eastmoney.com/kuaixun/v2/api/list?column=zhiboall&limit=20";
                common.jsonP(url, function (json) {
                    if (json.rc == 1) {
                        //上方的直播
                        var random = parseInt(Math.random() * 20);
                        if (json.news[random]) {
                            var item = json.news[random];
                            if(item.url_unique == ''){
                                item.url_unique = item.url_w
                            }
                            $("#ScrollMIIRBox .dt").html(item.showtime);
                            if(item.newstype == '2'){
                                $("#ScrollMIIRBox .t").html('<span>' + item.title + '</span>');
                            }
                            else{
                                $("#ScrollMIIRBox .t").html('<a href="' + item.url_unique + '" target="_blank">' + item.title + '</a>');
                            }
                            
                        }

                        var html = "";
                        for (var i = 0; i < json.news.length; i++) {
                            var itemNews = json.news[i];
                            if(itemNews.url_unique == ''){
                                itemNews.url_unique = itemNews.url_w
                            }
                            var time = itemNews.showtime.split(" ")[1];
                            html += '<li><span class="kx_itime">' + time + '</span>' +
                                '<span class="kx_itime_end">|</span>' +
                                '<span class="bd_i_txt">' +
                                '<a href="' + itemNews.url_unique + '" target="_blank">' +
                                itemNews.title + '&nbsp;[点击查看全文]</a></span></li>';
                        }

                        $("#stockBroadcast").html(html);
                    }
                }, null);
            }
        }
        return stockBroadcast;
    }

    // 热门股吧
    baseStock.prototype.setHotGuba = function (length) {
        var base = this
        //var url = $("#GetHotGuba").val();
        // var url = "http://quote.eastmoney.com/web/api/stockapi/GetHotGuba"
        // $.ajax({
        //     type: "GET",
        //     url: url,
        //     data: { count: length },
        //     dataType: "json",
        //     success: function (data) {
        //         if (data.success) {
        //             var codeList = data.data.join(",");
        //             var arr = []
        //             for (var i = 0; i < data.data.length; i++) {
        //                 var market = data.data[i].slice(6, 7)
        //                 var code = data.data[i].slice(0, 6)
        //                 arr.push((market == 1 ? 1 : 0) + '.' + code)
        //             }
        //             var codestr = arr.join(",")
        //             var url = base.baseUrl + '/api/qt/ulist.np/get?secids=' + codestr + "&ut=" + base.ut + '&fid=f3&fields=f1,f2,f3,f12,f13,f14,f152'
        //             base.bindDataTemplatenew(url, "hotGuba", "guba");

        //         }
        //     }
        // });
        if(hotguba){
          var codeList = hotguba.join(",");
          var arr = []
          for (var i = 0; i < hotguba.length; i++) {
              var market = hotguba[i].slice(6, 7)
              var code = hotguba[i].slice(0, 6)
              arr.push((market == 1 ? 1 : 0) + '.' + code)
          }
          var codestr = arr.join(",")
          var url = base.baseUrl + '/api/qt/ulist.np/get?secids=' + codestr + "&ut=" + base.ut + '&fid=f3&fields=f1,f2,f3,f12,f13,f14,f152'
          base.bindDataTemplatenew(url, "hotGuba", "guba");
        }
    }

    // JS行情图
    baseStock.prototype.setChart = function () {
        var _this = this
        var setChart = {
            init: function () {
                this.bindEvent();
                //
                if ($('#h5_show').is('.cur')) {
                    this.set();
                    _this.h5hasset = 1
                }
                
                $("#actTabImg").css({"display":"block"});
                $("#actTabFs").css({ "display": "none" });
            },
            bindEvent: function () {
                var _that = this
                $("#image_show").click(function () {
                    $("#h5_show").removeClass("cur");
                    $(this).addClass("cur");
                    $("#img_container").show();
                    $("#h5_container").hide();
                    $("#actTabImg").css({ "display": "block" });
                    $("#actTabFs").css({ "display": "none" });
                });
                $("#h5_show").click(function () {
                    if(_this.h5hasset != 1){
                        
                        _that.set()
                        _this.h5hasset = 1
                    }

                    $("#image_show").removeClass("cur");
                    $(this).addClass("cur");
                    $("#img_container").hide();
                    $("#h5_container").show();
                    $("#actTabFs").css({ "display": "block" });
                    $("#actTabImg").css({ "display": "none" });
                });
            },
            set: function () {
                emChart.initial();
            }
        }
        return setChart;
    }

    //列表模板
    baseStock.prototype.bindDataTemplate = function (url, containerId, type) {
        var html = "";
        common.jsonPnew(url, function (json) {
            if (json.length == 0) {
                return;
            }

            if (type.indexOf("NO") >= 0) {
                html += '<tbody>';
            } else {
                html += '<tbody><tr><th>名称</th><th>最新价</th><th>涨跌幅</th></tr>';
            }

            for (var i = 0; i < json.length; i++) {
                if (!json[i]) continue;
                var itemlist = json[i].split(",");
                var color = common.getColor(itemlist[4]);

                var stockCode = itemlist[1];
                var stockName = itemlist[2];

                if (common.getByteLen(stockName) > 12) {
                    //判断中英文
                    if (stockName.match(/[^\x00-\xff]/ig) != null) {
                        stockName = stockName.substring(0, 6) + "..";
                    } else {
                        stockName = stockName.substring(0, 12) + "..";
                    }
                }

                var stockUrl = "http://quote.eastmoney.com";

                if (type == "global") {
                    if (stockName == "上证指数" || stockName == "深证成指") {
                        stockUrl += "/zs" + stockCode + ".html";
                    } else if (stockName == "恒生指数") {
                        stockUrl += "/hk/zs110000.html";
                    } else {
                        stockUrl += "/gb/zs" + stockCode + ".html";
                    }
                }

                if (type == "AB" || type == "AB_NO") {
                    if (itemlist[1].indexOf("BK") >= 0) {
                        stockUrl += "/web/" + stockCode + "1.html";
                    } else if (itemlist[0] == "1") {
                        stockUrl += "/sh" + stockCode + ".html";
                    } else if (itemlist[0] == "2") {
                        stockUrl += "/sz" + stockCode + ".html";
                    }
                }

                if (type == "guba") {
                    stockUrl = "http://guba.eastmoney.com/list," + stockCode + ".html";
                    stockName += "吧";
                }

                if (type == "globalFuture") {
                    stockUrl += "/globalfuture/" + stockCode + ".html";
                }

                if (type == "forex") {
                    if (stockCode == "DINI") {
                        stockUrl += "/qihuo/dini.html";
                    } else {
                        stockUrl += "/forex/" + stockCode + ".html";
                    }
                }

                if (type == "hk") {
                    stockUrl += "/hk/" + stockCode + ".html";
                }

                if (type == "index" || type == "index_NO") {
                    stockUrl += "/zs" + stockCode + ".html";
                }

                if (type == "us") {
                    stockUrl += "/us/" + stockCode + ".html";
                }

                if (type == "xh") {
                    stockUrl = "";
                    //stockUrl += "/web/" + stockCode + "8.html";
                }

                if (type == "gzqh") {
                    stockUrl += "/gzqh/" + stockCode + ".html";
                }

                if (type == "future") {
                    //判断是否为股指期货
                    if (itemlist[0] == "_ITFFO") {
                        stockUrl += "/gzqh/" + stockCode + ".html";
                    } else {
                        stockUrl += "/qihuo/" + stockCode + ".html";
                    }
                }
                html += '<tr>'
                    + '<td>'
                    + (stockUrl ? ('<a href="' + stockUrl + '" target="_blank" title="' + itemlist[2] + '">' + stockName + '</a>') : stockName)
                    + '</td>'
                    + '<td class="' + color + '">' + itemlist[3] + '</td>'
                    + '<td class="' + color + '">' + itemlist[4] + '</td>'
                    + '</td></tr>';
            }
            html += "</tbody>";
            $("#" + containerId).html(html);
        });

    }

    //列表模板接新行情
    baseStock.prototype.bindDataTemplatenew = function (url, containerId, type) {
        var html = "";
        $.ajax({
            type: "GET",
            url: url,
            data: null,
            dataType: 'jsonp',
            jsonp: 'cb',
            success: function (res) {
                // console.info(url)
                // console.info(res)
                var data = res.data.diff;
                var json = []
                if (type == 'AB' || type == 'guba' || type == 'AB_NO' || type == 'future' || type == 'us' || type == 'globalFuture' || type == 'global') {
                    if (data instanceof Array) {
                        for (var i = 0; i < data.length; i++) {
                            var stritem = data[i].f13 + ',' + data[i].f12 + ',' + data[i].f14 + ',' + (data[i].f2 == '-' ? data[i].f2 : (data[i].f2 / Math.pow(10, data[i].f1)).toFixed(data[i].f1)) + ',' + (data[i].f3 == '-' ? '-' : ((data[i].f3 / Math.pow(10, data[i].f152)).toFixed(data[i].f152) + '%'))
                            json.push(stritem)
                        }
                    } else {
                        for (var i in data) {
                            var stritem = data[i].f13 + ',' + data[i].f12 + ',' + data[i].f14 + ',' + (data[i].f2 == '-' ? data[i].f2 : (data[i].f2 / Math.pow(10, data[i].f1)).toFixed(data[i].f1)) + ',' + (data[i].f3 == '-' ? '-' : ((data[i].f3 / Math.pow(10, data[i].f152)).toFixed(data[i].f152) + '%'))
                            json.push(stritem)
                        }
                    }
                } else if (type == 'ZDF') {
                    for (var i in data) {
                        var stritem = data[i].f13 + ',' + data[i].f12 + ',' + data[i].f14 + ',' + (data[i].f2 / Math.pow(10, data[i].f1)).toFixed(2) + ',' + ((data[i].f3 / Math.pow(10, data[i].f152)).toFixed(data[i].f152) + '%')
                        json.push(stritem)
                    }
                } else if (type == 'hk') {
                    for (var i = 0; i < data.length; i++) {
                        var stritem = data[i].f13 + ',' + data[i].f12 + ',' + data[i].f14 + ',' + ((data[i].f2 == '-' ? data[i].f2 : data[i].f2.toFixed(3)) + ',' + (data[i].f3 == '-' ? data[i].f3 : (data[i].f3).toFixed(data[i].f152) + '%'))
                        json.push(stritem)
                    }
                } else if (type == 'forex') {
                    for (var i = 0; i < data.length; i++) {
                        var stritem = data[i].f13 + ',' + data[i].f12 + ',' + data[i].f14 + ',' + (data[i].f2 / Math.pow(10, data[i].f1)).toFixed(data[i].f1) + ',' + ((data[i].f3 / Math.pow(10, data[i].f152)).toFixed(data[i].f152) + '%')
                        json.push(stritem)
                    }
                }
                if (type.indexOf("NO") >= 0) {
                    html += '<tbody>';
                } else {
                    html += '<tbody><tr><th>名称</th><th>最新价</th><th>涨跌幅</th></tr>';
                }
                for (var i = 0; i < json.length; i++) {
                    var itemlist = json[i].split(",");
                    var color = common.getColor(itemlist[4]);
                    var stockCode = itemlist[1];
                    var stockName = itemlist[2];
                    if (common.getByteLen(stockName) > 12) {
                        //判断中英文
                        if (stockName.match(/[^\x00-\xff]/ig) != null) {
                            stockName = stockName.substring(0, 6) + "..";
                        } else {
                            stockName = stockName.substring(0, 12) + "..";
                        }
                    }

                    var stockUrl = "http://quote.eastmoney.com";
                    if (type == "AB" || type == "AB_NO") {
                        if (itemlist[1].indexOf("BK") >= 0) {
                            stockUrl += "/web/" + stockCode + "1.html";
                        } else if (itemlist[0] == "1") {
                            stockUrl += "/sh" + stockCode + ".html";
                        } else if (itemlist[0] == "0") {
                            stockUrl += "/sz" + stockCode + ".html";
                        }
                    } else if (type == "guba") {
                        stockUrl = "http://guba.eastmoney.com/list," + stockCode + ".html";
                        stockName += "吧";
                    } else if (type == "ZDF") {
                        if (itemlist[0] == "1") {
                            stockUrl += "/sh" + stockCode + ".html";
                        } else if (itemlist[0] == "0") {
                            stockUrl += "/sz" + stockCode + ".html";
                        }
                    } else if (type == "future") {
                        if (itemlist[0] == 8) {
                            var gzname = stockName.replace("连续", "");
                            var gzcode = gzname.replace("当月", "DYLX").replace("下月", "XYLX").replace("当季", "GZDJLX");
                            if (gzname.indexOf('IF') < 0) { gzcode = gzcode.replace("LX", ""); }
                            stockUrl = "http://quote.eastmoney.com/gzqh/" + gzcode + ".html";
                        } else {
                            stockUrl = "http://quote.eastmoney.com/qihuo/" + stockCode + ".html";
                        }
                    } else if (type == "us") {
                        stockUrl = "http://quote.eastmoney.com/us/" + stockCode + ".html";
                    } else if (type == "hk") {
                        stockUrl = "http://quote.eastmoney.com/hk/" + stockCode + ".html";
                    } else if (type == "forex") {
                        if (itemlist[0] == 100) {
                            stockUrl = "http://quote.eastmoney.com/globalfuture/" + stockCode + ".html";
                        } else {
                            stockUrl = "http://quote.eastmoney.com/forex/" + stockCode + ".html";
                        }
                    } else if (type == "globalFuture") {
                        stockUrl = "http://quote.eastmoney.com/globalfuture/" + stockCode + ".html";
                    } else if (type == "global") {
                        if (itemlist[0] == 0 || itemlist[0] == 1) {
                            stockUrl = "http://quote.eastmoney.com/zs" + stockCode + ".html";
                        } else {
                            stockUrl = "http://quote.eastmoney.com/gb/zs" + stockCode + ".html";
                        }
                    }
                    html += '<tr>'
                        + '<td>'
                        + (stockUrl ? ('<a href="' + stockUrl + '" target="_blank" title="' + itemlist[2] + '" style=" block;width: 0px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">' + stockName + '</a>') : stockName)
                        + '</td>'
                        + '<td class="' + color + '">' + (itemlist[3] == 0 ? '-' : itemlist[3]) + '</td>'
                        + '<td class="' + color + '">' + (itemlist[3] == 0 ? '-' : itemlist[4]) + '</td>'
                        + '</td></tr>';
                }

                html += "</tbody>";
                $("#" + containerId).html(html);

            }
        });
    }

    // 获取文章列表
    baseStock.prototype.getArticle = function (articleNum, containerId) {
        var url = $("#GetArticle").val();
        $.ajax({
            type: "GET",
            url: url,
            data: {
                articleNum: articleNum
            },
            dataType: "json",
            success: function (data) {
                if (data && data.success) {
                    if (data.data.length >= 5) {
                        var html = "";
                        for (var i = 0; i < data.data.length; i++) {
                            var item = data.data[i];
                            html += '<li class="clearfix">' +
                                '<a href="' + item.url + '" target="_blank" class="fl">' + item.title + '</a>' +
                                '<i class="fr">' + item.date + '</i></li>';
                        }
                        $("#" + containerId).html(html);
                    }
                }
            }
        });
    }

    //自选股
    baseStock.prototype.getFavouriteStock = function (num) {
        return false
        // var count = num || 5;
        // var base = this;
        // var pi = common.getCookie("pi");
        // var initlist = "300059,000016,000017,300268,000001,000002,000005,000006,000008";
        // var emhq_stock = common.getCookie("emhq_stock");
        // if (emhq_stock) {
        //     initlist = emhq_stock;
        // }
        // var itemlist = initlist.split(",");
        // var stockList = new Array();
        // for (var i = 0; i < itemlist.length; i++) {
        //     stockList.push(itemlist[i] + common.getMarketCode(itemlist[i]));
        // }
        // if (pi) {
        //     if (pi.split(';').length >= 3) {
        //         var name = pi.split(';')[2];
        //         if (!/^[\u4E00-\u9FA5][0-9a-zA-Z]{6}$/g.test(name)) {
        //             $.getScript("https://myfavor.eastmoney.com/mystock?f=gsaandcheck&sc=" + base.code + "|0" + base.market + "|01&c=" + count + "&var=favorStock", function () {
        //                 var allstocklist = [];
        //                 if (favorStock.result == "1") {
        //                     var sl = favorStock.data.list.split(',');
        //                     for (var i = 0; i < sl.length; i++) {
        //                         var item = sl[i].split('|');
        //                         var stockId = item[0] + common.getMarketCode(item[0]);
        //                         allstocklist.push(stockId);
        //                     }
        //                     allstocklist = allstocklist.concat(stockList).unique().slice(0, count);
        //                     var url = "http://nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx?type=CT&cmd=" + allstocklist.join(',') + "&sty=MPNSBAS&st=z&p=1&ps=" + count + "&cb=?&js=([(x)])&token=7bc05d0d4c3c22ef9fca8c2a912d779c";
        //                     base.bindDataTemplate(url, "favorTable", "AB");
        //                 }
        //             });
        //         }
        //     }
        // } else {
        //     var url = "http://nufm.dfcfw.com/EM_Finance2014NumericApplication/JS.aspx?type=CT&cmd=" + stockList.join(",") + "&sty=MPNSBAS&st=c&sr=-1&p=1&ps=" + count + "&cb=?&js=([(x)])&token=7bc05d0d4c3c22ef9fca8c2a912d779c";
        //     base.bindDataTemplate(url, "favorTable", "AB");
        // }
    }


    //自选股 接新行情 zxw
    /*
     *
     *@description: 板块、基金等多个模块引用了 baseStock.prototype.getFavouriteStocknew 修改的时候注意id变化
     *@modifyContent: 统一使用自选股模块renderzx
     *@author: qiuhongyang
     *@date: 2020-05-25 14:55:38
     *
    */
    baseStock.prototype.getFavouriteStocknew = function (num) {
        var count = num || 5; 
        // renderzx("myfavorite", count); 

        // var base = this;
        // var pi = common.getCookie("ct");
        // var initlist = "0.300059,0.000016,0.000017,0.300268,0.000001,0.000002,0.000005,0.000006,0.000008";
        // var emhq_stock = common.getCookie("emhq_stock");
        // if (emhq_stock) {
        //     initlist = emhq_stock;
        // }
        // var itemlist = initlist.split(",");
        // var stockList = new Array();
        // for (var i = 0; i < itemlist.length; i++) {
        //     stockList.push(itemlist[i]);
        // }
        // //原来只判断pi 废弃
        // if (common.getCookie("uidal") && common.getCookie("ut") && common.getCookie("ct")) {
        //     $.getScript("https://myfavor.eastmoney.com/mystock?f=gsaandcheck&sc=" + base.code + "|0" + base.market + "|01&c=" + count + "&var=favorStock", function () {
        //         var allstocklist = [];
        //         if (favorStock.result == "1") {
        //             var sl = favorStock.data.list.split(',');
        //             for (var i = 0; i < sl.length; i++) {
        //                 var item = sl[i].split('|');
        //                 var stockId = (common.getMarketCode(item[0]) == 2 ? 0 : common.getMarketCode(item[0])) + '.' + item[0]
        //                 allstocklist.push(stockId);
        //             }
        //             allstocklist = allstocklist.concat(stockList).unique().slice(0, count);
        //             var codestr = allstocklist.join(",")
        //             var url = base.baseUrl + '/api/qt/ulist.np/get?secids=' + codestr + "&ut=" + base.ut + '&fid=f3&fields=f1,f2,f3,f12,f13,f14,f152'
        //             base.bindDataTemplatenew(url, "favorTable", "AB");

        //         }
        //     }); 
        // } else {
        //         $.ajax({
        //             url: 'http://myfavor1.eastmoney.com/mystock_webanonym?f=gsaandcheck&sc=0.300059&c='+count+'&cb=?',
        //             type: 'GET',
        //             dataType: 'jsonp',
        //             data: {
                        
        //             }
        //         })
        //         .done(function(json) {   
        //             if (json.data && json.data.list && json.data.list.length > 0) {
        //                 var codestr = json.data.list
        //                 var url = base.baseUrl + '/api/qt/ulist.np/get?secids=' + codestr + "&ut=" + base.ut + '&fid=f3&fields=f1,f2,f3,f12,f13,f14,f152'
        //                 base.bindDataTemplatenew(url, "favorTable", "AB");
        //             }
        //         })
        //         .fail(function(error) {
                
        //         })
        //     // var codestr = stockList.slice(0, count).join(",")
            
        // }
    }

    module.exports = baseStock
    // return baseStock;
// });

